import WmsLayer from '@/components/vue-map/layers/wmsLayer.js'

export default class GwHeadsRefLayer extends WmsLayer {
  getValuesFromGeom (mapRef, geom) {
    let params = []
    params['INFO_FORMAT'] = 'json'
    return this.getFromGeom(mapRef, geom, params)
  }
}